import React from 'react';
import { connect } from 'react-redux';

import { IncorrectSequencesContainer } from '../../../Shared/index';
import questionActions from '../../actions/questions';

const ConnectIncorrectSequencesContainer = ({ incorrectSequences, match, dispatch }) => {
  const { questionID } = match.params;
  const baseUrl = `#${match.url}`;

  const handleUpdateSequences = (questionID, sequences, callback) => {
    dispatch(questionActions.updateIncorrectSequences(questionID, sequences, callback));
  };

  const handleDeleteSequence = (questionID, sequenceID) => {
    dispatch(questionActions.deleteIncorrectSequence(questionID, sequenceID));
  };

  const handleSubmitEditedSequence = (questionID, data, key) => {
    dispatch(questionActions.submitEditedIncorrectSequence(questionID, data, key));
  };

  return (
    <IncorrectSequencesContainer
      baseUrl={baseUrl}
      incorrectSequences={incorrectSequences}
      onDeleteSequence={handleDeleteSequence}
      onSubmitEditedSequence={handleSubmitEditedSequence}
      onUpdateSequences={handleUpdateSequences}
      questionID={questionID}
    />
  );
};

function select(state, ownProps) {
  const { questionID } = ownProps.match.params;
  const question = state.questions.data[questionID];

  return {
    incorrectSequences: question?.incorrectSequences || {},
  };
}

export default connect(select)(ConnectIncorrectSequencesContainer);
